/* ============
 * WarehouseReport Transformer
 * ============
 *
 * todo: add documentation here!
 */

import Transformer from './transformer';

export default class WarehouseReportTransformer extends Transformer {

  static fetch(item) {
    return {
      productName: item.product_name,
      nameOfWarehouse: item.name_of_warehouse,
      productNumber: item.product_number,
      productValue: (item.product_value).toLocaleString('no-NB', { style: 'currency', currency: 'NOK' }),
      vmpNumber: item.vmp_number,
      qtyAvailable: item.qty_available,
      crateQtyAvailable: item.qty_crate,
    };
  }

  static send() {
    return {
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/warehouseReport.js